import type { ClientHandover } from '@/types/client-workstreams';

export interface ClientHandoverRequest { workId: string; workspaceId: string; actorId: string; existing?: boolean; }
const drafts = new Map<string, ClientHandover>();
let pending: (ClientHandoverRequest & { draft?: ClientHandover; resolve: (value: ClientHandover | null) => void }) | null = null;
const listeners = new Set<() => void>();
export const handoverDialogStore = {
  subscribe: (listener: () => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; },
  getSnapshot: () => pending,
  finish: (value: ClientHandover | null) => {
    const current = pending;
    if (current) { if (value) drafts.set(current.workId, value); else drafts.delete(current.workId); }
    pending = null;
    listeners.forEach(listener => listener());
    current?.resolve(value);
  },
  forget: (workId: string) => { drafts.delete(workId); },
  reset: () => {
    drafts.clear();
    const current = pending; pending = null;
    listeners.forEach(listener => listener());
    current?.resolve(null);
  },
};
export function requestClientHandover(request: ClientHandoverRequest): Promise<ClientHandover | null> {
  if (pending) throw new Error('Finish the open client handover first.');
  return new Promise(resolve => { pending = { ...request, draft: drafts.get(request.workId), resolve }; listeners.forEach(listener => listener()); });
}
